// extracted by mini-css-extract-plugin
export default {"phone":"headerPhone-module__phone--TJF5s"};